<div>
    <!--        Filters-->
    <div class="border border-divider p-6 flex flex-col gap-4">
        <h2 class="m-0 typography-title-s">
            {{'create-claim.material-selection.use_the_filters_to_see_materials' | translate}}
        </h2>

        <div *ngIf="relatedFabricators && relatedFabricators.length > 1">
            <div class="flex flex-col md:flex-row items-start md:items-center gap-2 flex-1 basis-full md:basis-0">
                <label [for]="fabricatorInput" class="typography-body-m-medium">
                    {{'create-claim.material-selection.indicate_the_buyer_of_the_material' | translate}}
                </label>
                <div class="flex w-full md:w-auto">
                    <app-select
                        class="flex-1"
                        #fabricatorInput
                        [placeholder]="'select' | translate"
                        [options]="relatedFabricators"
                        [selectedValue]="selectedRelatedFabricator"
                        [required]="false"
                        [searchable]="false"
                        [isClearable]="false"
                        (selectedValueChanged)="onFabricatorSelected($event)"
                    ></app-select>
                </div>
            </div>
        </div>
        <!--            Invoice, lot and material-->
        <div class="flex flex-wrap gap-4">
            <!--            Dates range-->
            <div class="flex-1 basis-full md:basis-0">
                <label [for]="picker" class="typography-body-m-medium">
                    {{'create-claim.material-selection.range_date' | translate}}
                </label>
                <div class="mt-2">
                    <mat-form-field class="w-full md:w-auto border border-divider">
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate [ngModel]="startDate" (dateChange)="onStartDateChange($event)" [placeholder]="'global.from' | translate">
                            <input matEndDate [ngModel]="endDate" (dateChange)="onEndDateChange($event)" [placeholder]="'global.to' | translate">
                        </mat-date-range-input>

                        <mat-datepicker-toggle [disableRipple]="true" matIconPrefix [for]="picker">
                            <mat-icon matDatepickerToggleIcon>
                                <img src="assets/icons/datepicker.svg" alt="date" />
                            </mat-icon>
                        </mat-datepicker-toggle>

                        <mat-datepicker-toggle *ngIf="startDate || endDate" [disableRipple]="true" matIconSuffix (click)="clearDateRange()">
                            <mat-icon matDatepickerToggleIcon>
                                <img src="assets/icons/close-black.svg" alt="clear" />
                            </mat-icon>
                        </mat-datepicker-toggle>
                        <mat-date-range-picker #picker (yearSelected)="maxDate.getFullYear()" [startAt]="maxDate"></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>
            <div class="flex flex-col flex-1 basis-full md:basis-0">
                <label [for]="invoiceNumberInput" class="typography-body-m-medium">
                    {{'create-claim.material-selection.invoice_number' | translate}}
                </label>
                <div class="flex flex-1 mt-2">
                    <input
                        #invoiceNumberInput
                        type="text"
                        class="input flex-1 py-2 px-4 typography-body-m-regular border border-divider"
                        [placeholder]="'example_small' | translate: { varExample: '0000000000'}"
                        [(ngModel)]="invoiceNumber"
                        (keyup.enter)="onFilter()"
                        (focusout)="onFilter()"
                    >
                </div>
            </div>

            <div class="flex flex-col flex-1 basis-full md:basis-0">
                <label [for]="lotNumberInput" class="typography-body-m-medium">
                    {{'create-claim.material-selection.lot_number' | translate}}
                </label>
                <div class="flex flex-1 mt-2">
                    <input
                        #lotNumberInput
                        type="text"
                        class="input flex-1 py-2 px-4 typography-body-m-regular border border-divider"
                        [placeholder]="'example_small' | translate: { varExample: '0000000000'}"
                        [(ngModel)]="lotNumber"
                        (keyup.enter)="onFilter()"
                        (focusout)="onFilter()"
                    >
                </div>
            </div>

            <div class="flex-1 basis-full md:basis-0">
                <label [for]="colorInput" class="typography-body-m-medium">
                    {{'create-claim.material-selection.color' | translate}}
                </label>
                <div class="flex mt-2">
                    <app-select
                        class="flex-1"
                        #colorInput
                        [placeholder]="'select' | translate"
                        [options]="availableColors"
                        [selectedValue]="color"
                        [required]="false"
                        [searchable]="true"
                        (selectedValueChanged)="onColorFilter($event)"
                    ></app-select>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="filteredInvoices" class="flex flex-col gap-4 mt-8">

        <div>
            <span class="typography-body-m-medium">{{totalInvoiceNumber}}</span>
            <span class="typography-body-m-regular">
                {{'create-claim.material-selection.results' | translate}}
            </span>
        </div>

        <alert *ngIf="type === 'claim'" type="info">
            {{'create-claim.material-selection.to_include_more_than_one_product' | translate}}
        </alert>

        <div>
            <div class="border border-text-tertiary">
                <app-table
                    class="flex-1"
                    [class.with-pagination]="true"
                    [data]="filteredInvoices"
                    [columns]="tableColumns"
                    [selectable]="true"
                    [selectedItems]="selectedInvoices"
                    [hoverOnDisabled]="true"
                    [tooltipOnDisabled]="disabledReason"
                    (selectionChanged)="onColorSelect($event)"
                    [noDataMessage]="'create-claim.material-selection.no_results' | translate"
                ></app-table>
            </div>

            <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (onPageChange)="onPageChange($event)"></app-pagination>
        </div>
    </div>

    <div *ngIf="!filteredInvoices" class="mt-8 ">
        <alert type="warning">
            <p class="m-0 typography-body-l-regular">
                {{'create-claim.material-selection.use_filters_to_see_invoices' | translate}}
            </p>
        </alert>
    </div>
    <div *ngIf="!filteredInvoices && initialSelectedInvoices && initialSelectedInvoices.length > 0" class="mt-8">
        <div class="border border-text-tertiary">
            <app-table
                class="flex-1"
                [data]="initialSelectedInvoices"
                [columns]="tableColumns"
                [selectable]="true"
                [selectedItems]="initialSelectedInvoices"
                [hoverOnDisabled]="true"
                [tooltipOnDisabled]="disabledReason"
                (selectionChanged)="onColorSelect($event)"
                [noDataMessage]="'create-claim.material-selection.no_results' | translate"
            ></app-table>
        </div>
    </div>
</div>

